/**
 * DO NOT MODIFY WITH AUTO FORMATTING!
 * This is a constant value for the default definition of the agent builder.
 * It must be in this format to be displayed correctly in the textarea field.
 */
export const AGENT_BUILDER_DEFAULT_DEFINITION_VALUE = `{
    "type": "function",
    "function": {
    "name": "get_current_time",
    "description": "Get the current time in a given location",
    "parameters": {
        "type": "object",
        "properties": {
            "location": {
                "type": "string",
                "description": "The city name, e.g. San Francisco"
            }
        },
        "required": ["location"]
        }
    }
}`;